export default {
  // Approximate stripe webhook delay
  RESUBSCRIBE_TIMEOUT: 5000,
};
